// extracted by mini-css-extract-plugin
module.exports = {"csr":"CorporateSocialResponsibility_csr__pee60"};